import { IScope } from "angular";
import {
  IFieldArray,
  IFieldConfigurationObject,
  IFieldGroup,
} from "AngularFormly";
import { cloneDeep, forEach } from "lodash";

interface EpromScope extends AngularFormly.ITemplateScope {
  createLocalFields: (index: number) => IFieldArray;
  getRepeatingFields(): unknown[];
  add(): void;
  remove(model: unknown): void;
}

export class EpromConfigurationsController {
  static $inject = ["$scope"];

  private repeatingFields: unknown[] = [];

  constructor(private readonly $scope: EpromScope) {
    $scope.getRepeatingFields = this.getRepeatingFields.bind(this);
    $scope.createLocalFields = this.createLocalFields.bind(this);
    $scope.add = this.add.bind(this);
    $scope.remove = this.remove.bind(this);
  }

  add() {
    const model = this.getModel();
    model.push({
      EpromType: "EPROM",
    });
  }

  remove(row: unknown) {
    const model = this.getModel();
    const index = model.indexOf(row);
    if (index > -1) {
      model.splice(index, 1);
    }
  }

  getRepeatingFields() {
    return this.repeatingFields;
  }

  getModel(): unknown[] {
    const options = this.$scope.options;
    if (!this.$scope.model) {
      return [];
    }
    return <unknown[]>this.$scope.model[options.key];
  }

  createLocalFields(index: number) {
    if (index === 0) {
      const fields = cloneDeep(this.$scope.to.osEpromField);
      this.addIds(fields, this.$scope.options.key, 0);
      return fields;
    }

    return this.createNewFields(index);
  }

  private createNewFields(index: number) {
    var newFields = cloneDeep(this.$scope.to.fields);
    this.addIds(newFields, this.$scope.options.key, index);
    return newFields;
  }

  private addIds(fields: IFieldArray, fieldsBaseName: string, index: number) {
    const that = this;
    forEach(fields, function (field) {
      const isFieldGroup = Object.keys(field).includes("fieldGroup");
      if (isFieldGroup) {
        const fieldGroup = <IFieldGroup>field;
        that.addIds(<IFieldArray>fieldGroup.fieldGroup, fieldsBaseName, index);
        return; // fieldGroups don't need an ID
      }

      if (field.templateOptions && field.templateOptions.fields) {
        that.addIds(field.templateOptions.fields, fieldsBaseName, index);
      }
      const fieldConfigurationObject = <IFieldConfigurationObject>field;
      var name = fieldConfigurationObject.name || field.key;
      fieldConfigurationObject.id = fieldConfigurationObject.name =
        fieldsBaseName + "[" + index.toString() + "]." + name;
    });
  }
}
